import React from 'react';

import Button from '../buttons/Button';
import BaseModal from '../modals/BaseModal';

function AddPhotosVideoModal({ open, onClose }) {
    return (
        <BaseModal open={open} handleClose={onClose}>
            <div className="w-full h-full sm:w-auto sm:h-auto flex flex-col justify-between gap-8">
                <div className="header sm:hidden p-6 text-center">
                    <h3>Kako naložiti fotografije</h3>
                </div>
                <div className="video flex-grow sm:w-[560px] sm:h-[315px] lg:w-[800px] lg:h-[450px]">
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/NYAf376mXb8?autoplay=1&iv_load_policy=33&rel=0"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="max-w-full"
                    />
                </div>
                <div className="footer sm:hidden text-right p-8">
                    <Button onClick={onClose} variant="outlined" color="secondary">
                        Zapri video
                    </Button>
                </div>
            </div>
        </BaseModal>
    );
}

export default AddPhotosVideoModal;
